import { Stage, useAutoUpdateSearchParams } from './useAutoUpdateSearchParams';
import { useAutoOpenBasicInfo } from './useAutoOpenBasicInfo';

export function useFormDataInit() {
    // Update url params.
    const stage = useAutoUpdateSearchParams();

    // Auto-open basic info if any data is missing.
    useAutoOpenBasicInfo(stage === Stage.Done);
}
